import { Component, type ReactNode } from 'react';
import { reportError } from '../lib/errors';

export class ErrorBoundary extends Component<{ children: ReactNode }, { error: Error | null }> {
  state = { error: null as Error | null };

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  componentDidCatch(error: Error) {
    console.error('[ErrorBoundary]', error);
    reportError('render', error);
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="app-shell screen flex flex-col items-center justify-center text-center gap-4 min-h-[100dvh]">
        <h1 className="text-title-1">Something went wrong</h1>
        <p className="text-fg-muted max-w-[32ch]">Your kitchen, plan and list are saved on this device. Reloading usually fixes it.</p>
        <button className="btn btn-primary" onClick={() => window.location.assign('/today')}>Reload</button>
      </div>
    );
  }
}
